import { render, staticRenderFns } from "./PollMultipleResultsBar.vue?vue&type=template&id=3130d240&scoped=true"
import script from "./PollMultipleResultsBar.vue?vue&type=script&lang=js"
export * from "./PollMultipleResultsBar.vue?vue&type=script&lang=js"
import style0 from "./PollMultipleResultsBar.vue?vue&type=style&index=0&id=3130d240&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3130d240",
  null
  
)

export default component.exports